"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Version_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersionFromGit = exports.getLocalVersion = exports.getCurrentBranch = exports.getCommitSha = exports.getBranchVersion = exports.compareVersions = exports.Version = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
const child_process_1 = require("child_process");
const package_json_1 = require("./package-json");
let Version = Version_1 = class Version {
    static compareVersions(branch = 'main', allowMatchWithoutError = false) {
        (0, child_process_1.execSync)(`git fetch origin ${branch}`, { encoding: 'utf8' });
        const branchVersion = Version_1.getBranchVersion(branch);
        const currentVersion = Version_1.getLocalVersion();
        const branchSha = Version_1.getCommitSha(`origin/${branch}`);
        const currentBranch = Version_1.getCurrentBranch();
        if (branchVersion !== currentVersion) {
            logger_1.log.info(`Version changed from [${branchVersion}] in [${branch}][${branchSha}] to [${currentVersion}] in [${currentBranch}] (latest local changes).`);
            return;
        }
        const message = `Version has not been changed. [${branchVersion}] in [${branch}][${branchSha}] is the same as [${currentVersion}] in [${currentBranch}] (latest local changes). Please update the version before committing.`;
        if (!allowMatchWithoutError) {
            throw new Error(message);
        }
        logger_1.log.warn(message);
    }
    static getBranchVersion(branch) {
        return Version_1.getVersionFromGit(`origin/${branch}`);
    }
    static getCommitSha(ref, short = true) {
        try {
            const command = `git rev-parse ${short ? '--short' : ''} ${ref}`;
            return (0, child_process_1.execSync)(command, { encoding: 'utf8' }).trim();
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get commit SHA for [${ref}] with error [${error.message}]`);
            }
            else {
                throw new Error(`Failed to get commit SHA for [${ref}] with unknown error.`);
            }
        }
    }
    static getCurrentBranch() {
        try {
            const command = `git rev-parse --abbrev-ref HEAD`;
            return (0, child_process_1.execSync)(command, { encoding: 'utf8' }).trim();
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get current branch name with error [${error.message}]`);
            }
            else {
                throw new Error(`Failed to get current branch name with unknown error.`);
            }
        }
    }
    static getLocalVersion(dir = process.cwd()) {
        const packageJson = package_json_1.PackageJson.getPackageJson({ startDir: dir });
        return packageJson.version;
    }
    static getVersionFromGit(ref) {
        try {
            const packageJsonContent = (0, child_process_1.execSync)(`git show ${ref}:package.json`, { encoding: 'utf8' });
            const data = JSON.parse(packageJsonContent);
            return data.version;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed fetching package.json from [${ref}] with error [${error.message}]`);
            }
            else {
                throw new Error(`Failed fetching package.json from [${ref}] with unknown error.`);
            }
        }
    }
};
exports.Version = Version;
exports.Version = Version = Version_1 = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], Version);
exports.compareVersions = Version.compareVersions, exports.getBranchVersion = Version.getBranchVersion, exports.getCommitSha = Version.getCommitSha, exports.getCurrentBranch = Version.getCurrentBranch, exports.getLocalVersion = Version.getLocalVersion, exports.getVersionFromGit = Version.getVersionFromGit;
//# sourceMappingURL=version.js.map